const NAME = "ASSISTANCE_ANALYSIS";

export default NAME;
